import { render, staticRenderFns } from "./leadCounters.vue?vue&type=template&id=5035dc7a&"
import script from "./leadCounters.vue?vue&type=script&lang=js&"
export * from "./leadCounters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports